import { createFileRoute } from '@tanstack/react-router';
import { CmsSectionsListPage } from '@pages/website';

/** CMS Section-Liste für eine Seite (/website/$pageId) */
export const Route = createFileRoute('/_authenticated/website/$pageId/')({
  component: function CmsSectionsRoute() {
    const { pageId } = Route.useParams();
    return <CmsSectionsListPage pageId={pageId} />;
  },
});
